import {
  IAccomodationForm,
  IExpenseClaimForm,
  IPerDiemClaimForm,
  IPerDimMappingForm,
  IPerKmMappingForm,
  IPerKmMappingTable,
  IPerKmClaimForm,
  IPerDimMappingTable,
  IExpenseTypeGlAccountMappingForm,
  IExpenseTypeAndGlAccountMappingTable,
  IDesignationAndModeOfJourneyMappingForm,
  IDesignationAndExpenseTypeMappingForm,
  IExpenseTypeLimitMappingForm,
  IDesignationAndAccomodationMappingForm,
  IDepartmentAndCostCenterMappingForm,
  IDepartmentAndCostCenterMappingTable,
  IDepartmentAndGlCodeMappingTable,
  IDepartmentAndGlCodeMappingForm,
  IClaimAndSubClaimMappingForm,
  ICountryAndCityMappingForm,
  ICountryAndCityMappingTable,
  IClaimAndSubClaimMappingTable,
  IModeOfJourneyForm,
  ITravelRequestFormGroupConfig,
  IHandsetMappingForm,
  IHandsetMappingTable,
  IConveyanceLimitMappingForm,
  IExpenseAntiPatternMappingForm,
  IConveyanceLimitMappingTable,
  IExchangeRateForm,
  ITaxCodeForm,
  TravelLifecycleStatus,
} from './travelreq.interface';
import {
  AccommodationTypeFormKeys,
  AntiPatternErrorType,
  ClaimLimitType,
  ExpenseAntiPatternMappingFormKeys,
  ExpenseClaimFormKey,
  ModeOfJourneyFormKeys,
  PerDiemFormKeys,
  PerKmClaimFormKeys,
  ReviewType,
  TourRequestType,
  TravelRequestApprovalType,
  TravelRequestHeaderFormKeys,
  TravelRequestLineItemSection,
} from './travelreq.enum';
import { IAntdDropdown } from '../../Requisitions/constants/requisition.interface';
import {
  ExpenseCategory,
  SystemApprovalStatus,
  SystemSubmissionStatus,
} from '../../../enums/common';

export const ALLOWED_PROFILE_EXTENSIONS = [
  '.jpg',
  '.jpeg',
  '.png',
  '.gif',
  '.webp',
  '.bmp',
  '.tiff',
];
export const ALLOWED_PROFILE_MAX_SIZE = 10 * 1024 * 1024;

export const DEFAULT_TRAVEL_REQ_FORM_VALUES: Record<
  TravelRequestHeaderFormKeys,
  any
> = {
  employee: null,
  claimCategory: null,
  claimSubCategory: null,
  purposeOfTravel: null,
  startDate: null,
  endDate: null,
  costCenter: null,
  fromCountry: null,
  fromCity: null,
  toCountry: null,
  toCity: null,
  budget: null,
  budgetCurrency: null,
  advanceAmount: null,
  advanceAmountCurrency: null,
  handsetModel: null,
  dateOfPurchase: null,
  imeiNo: null,
  cost: null,
  costCurrency: null,
  remarks: '',
  customer: null,
  billToCustomer: null,
  month: null,
};

// Default values for the Journey Form
export const DEFAULT_JOURNEY_FORM_VALUES: Omit<IModeOfJourneyForm, 'id'> = {
  modeOfJourney: null,
  fromDate: null,
  fromTime: null,
  fromCountry: null,
  fromCity: null,
  toDate: null,
  toTime: null,
  toCountry: null,
  toCity: null,
  remarks: '',
};

// Default values for the Accomodation Form
export const DEFAULT_ACCOMODATION_FORM_VALUES: Omit<IAccomodationForm, 'id'> = {
  accommodationType: null,
  checkInDate: null,
  checkOutDate: null,
  checkInTime: null,
  checkOutTime: null,
  country: null,
  city: null,
  remarks: '',
};

// Default values for the Expense Claim Form
export const DEFAULT_EXPENSE_CLAIM_FORM_VALUES: Omit<IExpenseClaimForm, 'id'> =
{
  expenseType: null,
  amount: null,
  currency: null,
  fromDate: null,
  toDate: null,
  fromCountry: null,
  fromCity: null,
  toCountry: null,
  toCity: null,
  modeOfTransport: null,
  vendor: null,
  vendorName: null,
  vendorGSTIN: '',
  vendorState: null,
  businessPurpose: null,
  paymentMethod: null,
  isPersonalExpense: false,
  invoiceNo: null,
  invoiceDate: null,
  pnrNo: null,
  gstCode: null,
  costCenter: null,
  glAccount: null,
  vehicleNo: null,
  lanNo: null,
  customer: null,
  noOfDays: null,
  dsaCode: null,
  remarks: '',
  [ExpenseClaimFormKey.HOTEL_NAME]: null,
  [ExpenseClaimFormKey.HOTEL_STATE]: null,
  [ExpenseClaimFormKey.HOTEL_CITY]: null,
  [ExpenseClaimFormKey.HOTEL_COUNTRY]: null,
  [ExpenseClaimFormKey.HOTEL_ADDRESS]: null,
  [ExpenseClaimFormKey.HOTEL_PHONE_NUMBER]: null,
  [ExpenseClaimFormKey.GST_IN]: null,
  [ExpenseClaimFormKey.HOTEL_ADDRESS_LAT]: undefined,
  [ExpenseClaimFormKey.HOTEL_ADDRESS_LNG]: undefined,
  cancellationReason: undefined,
  cancellationCharges: undefined,
  hasRefund: undefined,
  isCancellation: undefined,
  billToCustomer: false,
  expenseCategory: ExpenseCategory.EMPLOYEE,
  isException: false,
};

// Default values for the Per Diem Claim Form
export const DEFAULT_PER_DIEM_FORM_VALUES: Omit<IPerDiemClaimForm, 'id'> = {
  city: null,
  fromDate: null,
  toDate: null,
  noOfDays: null,
  rate: null,
  total: null,
  remarks: '',
};

// Default values for the Per Km Claim Form
export const DEFAULT_PER_KM_FORM_VALUES: Omit<IPerKmClaimForm, 'id'> = {
  modeOfTransport: null,
  fromDate: null,
  toDate: null,
  source: null,
  destination: null,
  fromMeter: 0,
  toMeter: 0,
  distanceInKm: 0,
  ratePerKm: 0,
  total: 0,
  approvedAmount: null,
  remarks: '',
  sourceLat: null,
  sourceLng: null,
  destinationLat: null,
  destinationLng: null,
};

// Default values for the Per Dim Mapping Form
export const DEFAULT_PER_DIM_MAPPING_FORM_VALUES: Omit<
  IPerDimMappingForm,
  'id'
> = {
  city: null,
  state: null,
  designation: null,
  amount: null,
  fromDate: null,
  toDate: null,
  remarks: '',
};

// Default values for the Per Dim Mapping Table
export const DEFAULT_PER_DIM_MAPPING_TABLE_VALUES: Omit<
  IPerDimMappingTable,
  'id'
> = {
  serialNo: 0,
  city: null,
  state: null,
  designation: null,
  amount: 0,
  fromDate: '',
  toDate: '',
  remarks: '',
  action: null,
};

// Default values for the Per Km Mapping Form
export const DEFAULT_PER_KM_MAPPING_FORM_VALUES: Omit<IPerKmMappingForm, 'id'> =
{
  modeOfTransport: null,
  grade: null,
  userId: null,
  monthlyLimit: null,
  ratePerKm: null,
  fromDate: null,
  toDate: null,
  amount: null,
  attachmentRequired: false,
  hasNoLimit: false,
};

// Default values for the Per Km Mapping Table
export const DEFAULT_PER_KM_MAPPING_TABLE_VALUES: Omit<
  IPerKmMappingTable,
  'id'
> = {
  serialNo: 0,
  modeOfTransport: null,
  grade: null,
  userId: null,
  monthlyLimit: null,
  ratePerKm: 0,
  action: null,
  amount: 0,
  approvedAmount: 0,
  fromDate: null,
  toDate: null,
  travelEmployee: null,
  attachmentRequired: false,
  travelGrade: null,
  travelModeofTransport: null,
  createdByUser: null,
  createdAt: null,
  updatedByUser: null,
  createdBy: null,
  updatedBy: null,
  updatedAt: null,
};

// Default values for the Expense Type and GL Account Mapping Form
export const DEFAULT_EXPENSE_TYPE_GL_ACCOUNT_MAPPING_FORM_VALUES: Omit<
  IExpenseTypeGlAccountMappingForm,
  'id'
> = {
  expenseType: null,
  glAccount: null,
};

// Default values for the Expense Type and GL Account Mapping Table
export const DEFAULT_EXPENSE_TYPE_GL_ACCOUNT_MAPPING_TABLE_VALUES: Omit<
  IExpenseTypeAndGlAccountMappingTable,
  'id'
> = {
  serialNo: 0,
  expenseType: '',
  glAccount: '',
  action: null,
};

// Default values for the Designation and Mode Of Journey Mapping Form
export const DEFAULT_DESIGNATION_MODE_OF_JOURNEY_MAPPING_FORM_VALUES: Omit<
  IDesignationAndModeOfJourneyMappingForm,
  'id'
> = {
  designation: null,
  modeOfJourney: null,
};

// Default values for the Designation and Expense Type Mapping Form
export const DEFAULT_DESIGNATION_EXPENSE_TYPE_MAPPING_FORM_VALUES: Omit<
  IDesignationAndExpenseTypeMappingForm,
  'id'
> = {
  designation: null,
  employee: null,
  grade: null,
  employmentType: null,
  claimCategory: null,
  claimSubCategory: null,
  expenseType: null,
  fromDate: null,
  toDate: null,
};

// Default values for the Expense Type Limit Mapping Form
export const DEFAULT_EXPENSE_TYPE_LIMIT_MAPPING_FORM_VALUES: Omit<
  IExpenseTypeLimitMappingForm,
  'id'
> = {
  grade: null,
  userId: null,
  claimLimitType: ClaimLimitType.PER_DAY,
  expenseType: null,
  amount: 0.0,
  fromDate: null,
  toDate: null,
  attachmentRequired: false,
  claimCategory: null,
  claimSubCategory: null,
  hasNoLimit: false,
};

export const DEFAULT_EXPENSE_ANTI_PATTERN_MAPPING_FORM_VALUES: Omit<
  IExpenseAntiPatternMappingForm,
  'id'
> = {
  [ExpenseAntiPatternMappingFormKeys.COMPANY_GROUP]: null,
  [ExpenseAntiPatternMappingFormKeys.COMPANY]: null,
  [ExpenseAntiPatternMappingFormKeys.CLAIM_CATEGORY]: null,
  [ExpenseAntiPatternMappingFormKeys.CLAIM_SUB_CATEGORY]: null,
  [ExpenseAntiPatternMappingFormKeys.ACCOMMODATION_TYPE]: null,
  [ExpenseAntiPatternMappingFormKeys.MODE_OF_JOURNEY]: null,
  [ExpenseAntiPatternMappingFormKeys.MODE_OF_TRANSPORT]: null,
  [ExpenseAntiPatternMappingFormKeys.EXPENSE_TYPE]: null,
  [ExpenseAntiPatternMappingFormKeys.COMPLEMENT_EXPENSE_TYPE]: null,
  [ExpenseAntiPatternMappingFormKeys.ERROR_TYPE]: AntiPatternErrorType.ERROR,
  [ExpenseAntiPatternMappingFormKeys.MESSAGE]: '',
};

// Default values for the Designation and Accomodation Mapping Form
export const DEFAULT_DESIGNATION_ACCOMODATION_MAPPING_FORM_VALUES: Omit<
  IDesignationAndAccomodationMappingForm,
  'id'
> = {
  designation: null,
  accommodationType: null,
};

// Default values for the Department and Cost Center Mapping Form
export const DEFAULT_DEPARTMENT_COST_CENTER_MAPPING_FORM_VALUES: IDepartmentAndCostCenterMappingForm =
{
  id: null,
  claimCategory: null,
  claimSubCategory: null,
  expenseType: null,
  glAccount: null,
};

// Default values for the Department and Cost Center Mapping Table
export const DEFAULT_DEPARTMENT_COST_CENTER_MAPPING_TABLE_VALUES: Omit<
  IDepartmentAndCostCenterMappingTable,
  'id'
> = {
  action: null,
  claimCategory: null,
  subClaimCategory: null,
  expenseType: null,
  glAccount: null,
  updatedBy: null,
  updatedAt: null,
  travelSubCategory: null,
  travelCategory: null,
  travelExpenseType: null,
  travelGlAccount: null,
  createdByUser: null,
  updatedByUser: null,
  createdBy: null,
  createdAt: null,
};

// Default values for the Department and GL Code Mapping Form
export const DEFAULT_DEPARTMENT_GL_CODE_MAPPING_FORM_VALUES: Omit<
  IDepartmentAndGlCodeMappingForm,
  'id'
> = {
  department: null,
  glCode: null,
};

// Default values for the Department and GL Code Mapping Table
export const DEFAULT_DEPARTMENT_GL_CODE_MAPPING_TABLE_VALUES: Omit<
  IDepartmentAndGlCodeMappingTable,
  'id'
> = {
  serialNo: 0,
  department: '',
  glCode: '',
  action: null,
};

// Default values for the Claim and Sub Claim Mapping Form
export const DEFAULT_CLAIM_SUB_CLAIM_MAPPING_FORM_VALUES: Omit<
  IClaimAndSubClaimMappingForm,
  'id'
> = {
  claimCategoryId: null,
  claimSubCategoryId: null,
  companyGroupId: null,
  companyId: null,
};

export const DEFAULT_EXCHANGE_RATE_MAPPING_FORM_VALUES: Omit<
  IExchangeRateForm,
  'id'
> = {
  sourceCurrencyId: null,
  targetCurrencyId: null,
  ratePerUnitInTarget: null,
  rateDate: null,
};

export const DEFAULT_TAX_CODE_FORM_VALUES: Omit<
  ITaxCodeForm,
  'id'
> = {
  name: null,
  description: null,
  erpCode: null,
  cgst: null,
  sgst: null,
  igst: null,
  ugst: null,
  countryId: null,
  stateId: null,
  HSNCode: null,
  taxPercentage: null,
  distributionChannelId: null,
  validFrom: new Date('1970-01-01'),
  validTo: new Date('2100-01-01'),
};

// Default values for the Claim and Sub Claim Mapping Table
export const DEFAULT_CLAIM_SUB_CLAIM_MAPPING_TABLE_VALUES: Omit<
  IClaimAndSubClaimMappingTable,
  'id'
> = {
  serialNo: 0,
  claimCategoryId: null,
  claimSubCategoryId: null,
  action: null,
  claimCategoryDetail: null,
  claimSubCategoryDetail: null,
  createdByUser: null,
  updatedByUser: null,
  createdBy: null,
  createdAt: null,
  updatedBy: null,
  updatedAt: null,
};

// Default values for the Country and City Mapping Form
export const DEFAULT_COUNTRY_AND_CITY_MAPPING_FORM_VALUES: Omit<
  ICountryAndCityMappingForm,
  'id'
> = {
  state: null,
  country: 54, // default value india
  // cities: [],
  city: null, //just for temprorary work
  serialNo: null,
  action: null,
};

// Default values for the Country and City Mapping Table
export const DEFAULT_COUNTRY_AND_CITY_MAPPING_TABLE_VALUES: Omit<
  ICountryAndCityMappingTable,
  'id'
> = {
  serialNo: 0,
  country: '',
  city: '',
  action: null,
};

export const DEFAULT_HANDSET_MAPPING_FORM_VALUES: Omit<
  IHandsetMappingForm,
  'id'
> = {
  userId: null,
  lastPurchaseDate: null,
  amount: null,
  limitCurrency: null,
  limit: null,
  remarks: null,
};

// Default values for the Country and City Mapping Table
export const DEFAULT_HANDSET_MAPPING_TABLE_VALUES: Partial<
  Omit<IHandsetMappingTable, 'id'>
> = {
  serialNo: 0,
  userId: '',
  lastPurchaseDate: '',
  amount: '',
  currency: '',
  limit: '',
  remarks: '',
  action: null,
};

export const DEFAULT_CONVEYANCE_LIMIT_MAPPING_FORM_VALUES: Partial<
  Omit<IConveyanceLimitMappingForm, 'id'>
> = {
  gradeId: null,
  startDate: null,
  endDate: null,
  frequencyInDays: null,
  amount: null,
  hasNoLimit: false,
};

export const DEFAULT_CONVEYANCE_LIMIT_MAPPING_TABLE_VALUES: Partial<
  Omit<IConveyanceLimitMappingTable, 'id'>
> = {
  gradeId: '',
  startDate: '',
  endDate: '',
  frequencyInDays: '',
  amount: '',
  action: null,
  hasNoLimit: false,
};

export const DEFAULT_FORM_FIELD_CONFIG: Record<
  TravelRequestLineItemSection,
  ITravelRequestFormGroupConfig
> = {
  [TravelRequestLineItemSection.HEADER]: {
    required: true,
    visible: true,
    fields: {
      [TravelRequestHeaderFormKeys.EMPLOYEE]: {
        key: TravelRequestHeaderFormKeys.EMPLOYEE,
        label: 'Employee',
        defaultLabel: 'Employee',
        required: true,
        visible: true,
        disabled: false,
      },
      [TravelRequestHeaderFormKeys.PURPOSE_OF_TRAVEL]: {
        key: TravelRequestHeaderFormKeys.PURPOSE_OF_TRAVEL,
        label: 'Purpose of travel',
        defaultLabel: 'Purpose of travel',
        required: true,
        visible: true,
        disabled: false,
      },
      [TravelRequestHeaderFormKeys.START_DATE]: {
        key: TravelRequestHeaderFormKeys.START_DATE,
        label: 'Start Date',
        defaultLabel: 'Start Date',
        required: true,
        visible: true,
        disabled: false,
      },
      [TravelRequestHeaderFormKeys.END_DATE]: {
        key: TravelRequestHeaderFormKeys.END_DATE,
        label: 'End Date',
        defaultLabel: 'End Date',
        required: true,
        visible: true,
        disabled: false,
      },
      [TravelRequestHeaderFormKeys.MONTH]: {
        key: TravelRequestHeaderFormKeys.MONTH,
        label: 'Month',
        defaultLabel: 'Month',
        required: false,
        visible: false,
        disabled: false,
      },

      [TravelRequestHeaderFormKeys.COST_CENTER]: {
        key: TravelRequestHeaderFormKeys.COST_CENTER,
        label: 'Cost Center',
        defaultLabel: 'Cost Center',
        required: true,
        visible: true,
        disabled: false,
      },
      [TravelRequestHeaderFormKeys.FROM_COUNTRY]: {
        key: TravelRequestHeaderFormKeys.FROM_COUNTRY,
        label: 'From Country',
        defaultLabel: 'From Country',
        required: true,
        visible: true,
        disabled: false,
      },
      [TravelRequestHeaderFormKeys.FROM_CITY]: {
        key: TravelRequestHeaderFormKeys.FROM_CITY,
        label: 'From City',
        defaultLabel: 'From City',
        required: true,
        visible: true,
        disabled: false,
      },
      [TravelRequestHeaderFormKeys.TO_COUNTRY]: {
        key: TravelRequestHeaderFormKeys.TO_COUNTRY,
        label: 'To Country',
        defaultLabel: 'To Country',
        required: true,
        visible: true,
        disabled: false,
      },
      [TravelRequestHeaderFormKeys.TO_CITY]: {
        key: TravelRequestHeaderFormKeys.TO_CITY,
        label: 'To City',
        defaultLabel: 'To City',
        required: true,
        visible: true,
        disabled: false,
      },
      [TravelRequestHeaderFormKeys.BUDGET]: {
        key: TravelRequestHeaderFormKeys.BUDGET,
        label: 'Budget',
        defaultLabel: 'Budget',
        required: true,
        visible: true,
        disabled: false,
      },
      [TravelRequestHeaderFormKeys.BUDGET_CURRENCY]: {
        key: TravelRequestHeaderFormKeys.BUDGET_CURRENCY,
        label: 'Budget Currency',
        defaultLabel: 'Budget Currency',
        required: true,
        visible: true,
        disabled: false,
      },
      [TravelRequestHeaderFormKeys.ADVANCE_AMOUNT]: {
        key: TravelRequestHeaderFormKeys.ADVANCE_AMOUNT,
        label: 'Advance Amount',
        defaultLabel: 'Advance Amount',
        required: true,
        visible: true,
        disabled: false,
      },
      [TravelRequestHeaderFormKeys.ADVANCE_AMOUNT_CURRENCY]: {
        key: TravelRequestHeaderFormKeys.ADVANCE_AMOUNT_CURRENCY,
        label: 'Advance Amount Currency',
        defaultLabel: 'Advance Amount Currency',
        required: true,
        visible: true,
        disabled: false,
      },
      [TravelRequestHeaderFormKeys.HANDSET_MODEL]: {
        key: TravelRequestHeaderFormKeys.HANDSET_MODEL,
        label: 'Handset Model',
        defaultLabel: 'Handset Model',
        required: false,
        visible: true,
        disabled: false,
      },
      [TravelRequestHeaderFormKeys.DATE_OF_PURCHASE]: {
        key: TravelRequestHeaderFormKeys.DATE_OF_PURCHASE,
        label: 'Date of purchase',
        defaultLabel: 'Date of purchase',
        required: false,
        visible: true,
        disabled: false,
      },
      [TravelRequestHeaderFormKeys.HANDSET_IMEI]: {
        key: TravelRequestHeaderFormKeys.HANDSET_IMEI,
        label: 'Handset IMEI',
        defaultLabel: 'Handset IMEI',
        required: false,
        visible: true,
        disabled: false,
      },
      [TravelRequestHeaderFormKeys.COST]: {
        key: TravelRequestHeaderFormKeys.COST,
        label: 'Cost',
        defaultLabel: 'Cost',
        required: false,
        visible: true,
        disabled: false,
      },
      [TravelRequestHeaderFormKeys.COST_CURRENCY]: {
        key: TravelRequestHeaderFormKeys.COST_CURRENCY,
        label: 'Currency',
        defaultLabel: 'Currency',
        required: false,
        visible: true,
        disabled: true,
      },
      [TravelRequestHeaderFormKeys.REMARKS]: {
        key: TravelRequestHeaderFormKeys.REMARKS,
        label: 'Remarks',
        defaultLabel: 'Remarks',
        required: false,
        visible: true,
        disabled: false,
      },
      [TravelRequestHeaderFormKeys.CUSTOMER]: {
        key: TravelRequestHeaderFormKeys.CUSTOMER,
        label: 'Customer',
        defaultLabel: 'Customer',
        required: false,
        visible: true,
        disabled: false,
      },
      [TravelRequestHeaderFormKeys.BILL_TO_CUSTOMER]: {
        key: TravelRequestHeaderFormKeys.BILL_TO_CUSTOMER,
        label: 'Bill To Customer',
        defaultLabel: 'Bill To Customer',
        required: false,
        visible: true,
        disabled: false,
      },
    },
  },
  [TravelRequestLineItemSection.MODE_OF_JOURNEY]: {
    required: true,
    visible: true,
    fields: {
      [ModeOfJourneyFormKeys.MODE_OF_JOURNEY]: {
        key: ModeOfJourneyFormKeys.MODE_OF_JOURNEY,
        label: 'Mode of journey',
        defaultLabel: 'Mode of journey',
        required: true,
        visible: true,
        disabled: false,
      },
      [ModeOfJourneyFormKeys.FROM_CITY]: {
        key: ModeOfJourneyFormKeys.FROM_CITY,
        label: 'From City',
        defaultLabel: 'From City',
        required: true,
        visible: true,
        disabled: false,
      },
      [ModeOfJourneyFormKeys.FROM_COUNTRY]: {
        key: ModeOfJourneyFormKeys.FROM_COUNTRY,
        label: 'From Country',
        defaultLabel: 'From Country',
        required: true,
        visible: true,
        disabled: false,
      },
      [ModeOfJourneyFormKeys.FROM_DATE]: {
        key: ModeOfJourneyFormKeys.FROM_DATE,
        label: 'From Date',
        defaultLabel: 'From Date',
        required: true,
        visible: true,
        disabled: false,
      },
      [ModeOfJourneyFormKeys.FROM_TIME]: {
        key: ModeOfJourneyFormKeys.FROM_TIME,
        label: 'From Time',
        defaultLabel: 'From Time',
        required: true,
        visible: true,
        disabled: false,
      },
      [ModeOfJourneyFormKeys.REMARKS]: {
        key: ModeOfJourneyFormKeys.REMARKS,
        label: 'Remarks',
        defaultLabel: 'Remarks',
        required: true,
        visible: true,
        disabled: false,
      },
      [ModeOfJourneyFormKeys.TO_CITY]: {
        key: ModeOfJourneyFormKeys.TO_CITY,
        label: 'To City',
        defaultLabel: 'To City',
        required: true,
        visible: true,
        disabled: false,
      },
      [ModeOfJourneyFormKeys.TO_COUNTRY]: {
        key: ModeOfJourneyFormKeys.TO_COUNTRY,
        label: 'To Country',
        defaultLabel: 'To Country',
        required: true,
        visible: true,
        disabled: false,
      },
      [ModeOfJourneyFormKeys.TO_DATE]: {
        key: ModeOfJourneyFormKeys.TO_DATE,
        label: 'To Date',
        defaultLabel: 'To Date',
        required: true,
        visible: true,
        disabled: false,
      },
      [ModeOfJourneyFormKeys.TO_TIME]: {
        key: ModeOfJourneyFormKeys.TO_TIME,
        label: 'To Time',
        defaultLabel: 'To Time',
        required: true,
        visible: true,
        disabled: false,
      },
    },
  },
  [TravelRequestLineItemSection.ACCOMMODATION_TYPE]: {
    fields: {
      [AccommodationTypeFormKeys.ACCOMMODATION_TYPE]: {
        key: AccommodationTypeFormKeys.ACCOMMODATION_TYPE,
        label: 'Accommodation Type',
        defaultLabel: 'Accommodation Type',
        required: true,
        visible: true,
        disabled: false,
      },
      [AccommodationTypeFormKeys.CHECK_IN_DATE]: {
        key: AccommodationTypeFormKeys.CHECK_IN_DATE,
        label: 'Check In Date',
        defaultLabel: 'Check In Date',
        required: true,
        visible: true,
        disabled: false,
      },
      [AccommodationTypeFormKeys.CHECK_IN_TIME]: {
        key: AccommodationTypeFormKeys.CHECK_IN_TIME,
        label: 'Check In Time',
        defaultLabel: 'Check In Time',
        required: true,
        visible: true,
        disabled: false,
      },
      [AccommodationTypeFormKeys.CHECK_OUT_DATE]: {
        key: AccommodationTypeFormKeys.CHECK_OUT_DATE,
        label: 'Check Out Date',
        defaultLabel: 'Check Out Date',
        required: true,
        visible: true,
        disabled: false,
      },
      [AccommodationTypeFormKeys.CHECK_OUT_TIME]: {
        key: AccommodationTypeFormKeys.CHECK_OUT_TIME,
        label: 'Check Out Time',
        defaultLabel: 'Check Out Time',
        required: true,
        visible: true,
        disabled: false,
      },
      [AccommodationTypeFormKeys.CITY]: {
        key: AccommodationTypeFormKeys.CITY,
        label: 'City',
        defaultLabel: 'City',
        required: true,
        visible: true,
        disabled: false,
      },
      [AccommodationTypeFormKeys.COUNTRY]: {
        key: AccommodationTypeFormKeys.COUNTRY,
        label: 'Country',
        defaultLabel: 'Country',
        required: true,
        visible: true,
        disabled: false,
      },
      [AccommodationTypeFormKeys.REMARKS]: {
        key: AccommodationTypeFormKeys.REMARKS,
        label: 'Remarks',
        defaultLabel: 'Remarks',
        required: true,
        visible: true,
        disabled: false,
      },
    },
    required: true,
    visible: true,
  },
  [TravelRequestLineItemSection.EXPENSE_CLAIM]: {
    fields: {
      [ExpenseClaimFormKey.EXPENSE_TYPE]: {
        key: ExpenseClaimFormKey.EXPENSE_TYPE,
        label: 'Expense Type',
        defaultLabel: 'Expense Type',
        required: true,
        visible: true,
        disabled: false,
      },
      [ExpenseClaimFormKey.FROM_DATE]: {
        key: ExpenseClaimFormKey.FROM_DATE,
        label: 'From Date',
        defaultLabel: 'From Date',
        required: false,
        visible: true,
        disabled: false,
      },
      [ExpenseClaimFormKey.TO_DATE]: {
        key: ExpenseClaimFormKey.TO_DATE,
        label: 'To Date',
        defaultLabel: 'To Date',
        required: false,
        visible: true,
        disabled: false,
      },
      [ExpenseClaimFormKey.FROM_COUNTRY]: {
        key: ExpenseClaimFormKey.FROM_COUNTRY,
        label: 'From Country',
        defaultLabel: 'From Country',
        required: true,
        visible: true,
        disabled: true,
      },
      [ExpenseClaimFormKey.FROM_CITY]: {
        key: ExpenseClaimFormKey.FROM_CITY,
        label: 'From City',
        defaultLabel: 'From City',
        required: false,
        visible: true,
        disabled: false,
      },
      [ExpenseClaimFormKey.TO_CITY]: {
        key: ExpenseClaimFormKey.TO_CITY,
        label: 'To City',
        defaultLabel: 'To City',
        required: false,
        visible: true,
        disabled: false,
      },
      [ExpenseClaimFormKey.TO_COUNTRY]: {
        key: ExpenseClaimFormKey.TO_COUNTRY,
        label: 'To Country',
        defaultLabel: 'To Country',
        required: true,
        visible: true,
        disabled: true,
      },
      [ExpenseClaimFormKey.VENDOR]: {
        key: ExpenseClaimFormKey.VENDOR,
        label: 'Vendor',
        defaultLabel: 'Vendor',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.VENDOR_GSTIN]: {
        key: ExpenseClaimFormKey.VENDOR_GSTIN,
        label: 'Vendor GSTIN',
        defaultLabel: 'Vendor GSTIN',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.VENDOR_STATE]: {
        key: ExpenseClaimFormKey.VENDOR_STATE,
        label: 'Vendor State',
        defaultLabel: 'Vendor State',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.VENDOR_NAME]: {
        key: ExpenseClaimFormKey.VENDOR_NAME,
        label: 'Vendor Name',
        defaultLabel: 'Vendor Name',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.BUSINESS_PURPOSE]: {
        key: ExpenseClaimFormKey.BUSINESS_PURPOSE,
        label: 'Business Purpose',
        defaultLabel: 'Business Purpose',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.PAYMENT_METHOD]: {
        key: ExpenseClaimFormKey.PAYMENT_METHOD,
        label: 'Payment Method',
        defaultLabel: 'Payment Method',
        required: false,
        visible: true,
        disabled: false,
      },
      [ExpenseClaimFormKey.AMOUNT]: {
        key: ExpenseClaimFormKey.AMOUNT,
        label: 'Amount',
        defaultLabel: 'Amount',
        required: true,
        visible: true,
        disabled: false,
      },
      [ExpenseClaimFormKey.CURRENCY]: {
        key: ExpenseClaimFormKey.CURRENCY,
        label: 'Currency',
        defaultLabel: 'Currency',
        required: true,
        visible: true,
        disabled: true,
      },
      [ExpenseClaimFormKey.IS_PERSONAL_EXPENSE]: {
        key: ExpenseClaimFormKey.IS_PERSONAL_EXPENSE,
        label: 'Paid by employee',
        defaultLabel: 'Paid by employee',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.INVOICE_NO]: {
        key: ExpenseClaimFormKey.INVOICE_NO,
        label: 'Invoice No',
        defaultLabel: 'Invoice No',
        required: false,
        visible: true,
        disabled: false,
      },
      [ExpenseClaimFormKey.PNR_NO]: {
        key: ExpenseClaimFormKey.PNR_NO,
        label: 'PNR No',
        defaultLabel: 'PNR No',
        required: false,
        visible: true,
        disabled: false,
      },
      [ExpenseClaimFormKey.INVOICE_DATE]: {
        key: ExpenseClaimFormKey.INVOICE_DATE,
        label: 'Invoice Date',
        defaultLabel: 'Invoice Date',
        required: false,
        visible: true,
        disabled: false,
      },
      [ExpenseClaimFormKey.GL_ACCOUNT]: {
        key: ExpenseClaimFormKey.GL_ACCOUNT,
        label: 'Gl Account',
        defaultLabel: 'Gl Account',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.GST_CODE]: {
        key: ExpenseClaimFormKey.GST_CODE,
        label: 'GST Code',
        defaultLabel: 'GST Code',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.MODE_OF_TRANSPORT]: {
        key: ExpenseClaimFormKey.MODE_OF_TRANSPORT,
        label: 'Mode of transport',
        defaultLabel: 'Mode of transport',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.COST_CENTER]: {
        key: ExpenseClaimFormKey.COST_CENTER,
        label: 'Cost Center',
        defaultLabel: 'Cost Center',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.VEHICLE_NO]: {
        key: ExpenseClaimFormKey.VEHICLE_NO,
        label: 'Vehicle No',
        defaultLabel: 'Vehicle No',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.LAN_NO]: {
        key: ExpenseClaimFormKey.LAN_NO,
        label: 'LAN No',
        defaultLabel: 'LAN No',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.CUSTOMER]: {
        key: ExpenseClaimFormKey.CUSTOMER,
        label: 'Customer',
        defaultLabel: 'Customer',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.DSA_CODE]: {
        key: ExpenseClaimFormKey.DSA_CODE,
        label: 'DSA Code',
        defaultLabel: 'DSA Code',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.REMARKS]: {
        key: ExpenseClaimFormKey.REMARKS,
        label: 'Remarks',
        defaultLabel: 'Remarks',
        required: true,
        visible: true,
        disabled: false,
      },

      [ExpenseClaimFormKey.HOTEL_NAME]: {
        key: ExpenseClaimFormKey.HOTEL_NAME,
        label: 'Hotel Name',
        defaultLabel: 'Hotel Name',
        required: false,
        visible: false,
        disabled: false,
      },

      [ExpenseClaimFormKey.HOTEL_ADDRESS]: {
        key: ExpenseClaimFormKey.HOTEL_ADDRESS,
        label: 'Hotel Address',
        defaultLabel: 'Hotel Address',
        required: false,
        visible: false,
        disabled: false,
      },

      [ExpenseClaimFormKey.HOTEL_COUNTRY]: {
        key: ExpenseClaimFormKey.HOTEL_COUNTRY,
        label: 'Hotel Country',
        defaultLabel: 'Hotel Country',
        required: false,
        visible: false,
        disabled: false,
      },

      [ExpenseClaimFormKey.HOTEL_STATE]: {
        key: ExpenseClaimFormKey.HOTEL_STATE,
        label: 'Hotel State',
        defaultLabel: 'Hotel State',
        required: false,
        visible: false,
        disabled: false,
      },

      [ExpenseClaimFormKey.HOTEL_CITY]: {
        key: ExpenseClaimFormKey.HOTEL_CITY,
        label: 'Hotel City',
        defaultLabel: 'Hotel City',
        required: false,
        visible: false,
        disabled: false,
      },

      [ExpenseClaimFormKey.GST_IN]: {
        key: ExpenseClaimFormKey.GST_IN,
        label: 'GSTIN',
        defaultLabel: 'GSTIN',
        required: false,
        visible: true,
        disabled: false,
      },

      [ExpenseClaimFormKey.HOTEL_PHONE_NUMBER]: {
        key: ExpenseClaimFormKey.HOTEL_PHONE_NUMBER,
        label: 'Hotel Phone No.',
        defaultLabel: 'Hotel Phone No.',
        required: false,
        visible: false,
        disabled: false,
      },

      [ExpenseClaimFormKey.BILL_TO_CUSTOMER]: {
        key: ExpenseClaimFormKey.BILL_TO_CUSTOMER,
        label: 'Bill to Customer',
        defaultLabel: 'Bill to Customer',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.NO_OF_DAYS]: {
        key: ExpenseClaimFormKey.NO_OF_DAYS,
        label: 'No of days',
        defaultLabel: 'No of days',
        required: false,
        visible: false,
        disabled: false,
      },
    },
    required: true,
    visible: true,
  },
  [TravelRequestLineItemSection.OFFICE_EXPENSE_CLAIM]: {
    fields: {
      [ExpenseClaimFormKey.EXPENSE_TYPE]: {
        key: ExpenseClaimFormKey.EXPENSE_TYPE,
        label: 'Expense Type',
        defaultLabel: 'Expense Type',
        required: true,
        visible: true,
        disabled: false,
      },
      [ExpenseClaimFormKey.FROM_DATE]: {
        key: ExpenseClaimFormKey.FROM_DATE,
        label: 'From Date',
        defaultLabel: 'From Date',
        required: false,
        visible: true,
        disabled: false,
      },
      [ExpenseClaimFormKey.TO_DATE]: {
        key: ExpenseClaimFormKey.TO_DATE,
        label: 'To Date',
        defaultLabel: 'To Date',
        required: false,
        visible: true,
        disabled: false,
      },
      [ExpenseClaimFormKey.FROM_COUNTRY]: {
        key: ExpenseClaimFormKey.FROM_COUNTRY,
        label: 'From Country',
        defaultLabel: 'From Country',
        required: true,
        visible: true,
        disabled: true,
      },
      [ExpenseClaimFormKey.FROM_CITY]: {
        key: ExpenseClaimFormKey.FROM_CITY,
        label: 'From City',
        defaultLabel: 'From City',
        required: false,
        visible: true,
        disabled: false,
      },
      [ExpenseClaimFormKey.TO_CITY]: {
        key: ExpenseClaimFormKey.TO_CITY,
        label: 'To City',
        defaultLabel: 'To City',
        required: false,
        visible: true,
        disabled: false,
      },
      [ExpenseClaimFormKey.TO_COUNTRY]: {
        key: ExpenseClaimFormKey.TO_COUNTRY,
        label: 'To Country',
        defaultLabel: 'To Country',
        required: true,
        visible: true,
        disabled: true,
      },
      [ExpenseClaimFormKey.VENDOR]: {
        key: ExpenseClaimFormKey.VENDOR,
        label: 'Vendor',
        defaultLabel: 'Vendor',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.VENDOR_GSTIN]: {
        key: ExpenseClaimFormKey.VENDOR_GSTIN,
        label: 'Vendor GSTIN',
        defaultLabel: 'Vendor GSTIN',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.VENDOR_STATE]: {
        key: ExpenseClaimFormKey.VENDOR_STATE,
        label: 'Vendor State',
        defaultLabel: 'Vendor State',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.VENDOR_NAME]: {
        key: ExpenseClaimFormKey.VENDOR_NAME,
        label: 'Vendor Name',
        defaultLabel: 'Vendor Name',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.BUSINESS_PURPOSE]: {
        key: ExpenseClaimFormKey.BUSINESS_PURPOSE,
        label: 'Business Purpose',
        defaultLabel: 'Business Purpose',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.PAYMENT_METHOD]: {
        key: ExpenseClaimFormKey.PAYMENT_METHOD,
        label: 'Payment Method',
        defaultLabel: 'Payment Method',
        required: false,
        visible: true,
        disabled: false,
      },
      [ExpenseClaimFormKey.AMOUNT]: {
        key: ExpenseClaimFormKey.AMOUNT,
        label: 'Amount',
        defaultLabel: 'Amount',
        required: true,
        visible: true,
        disabled: false,
      },
      [ExpenseClaimFormKey.CURRENCY]: {
        key: ExpenseClaimFormKey.CURRENCY,
        label: 'Currency',
        defaultLabel: 'Currency',
        required: true,
        visible: true,
        disabled: true,
      },
      [ExpenseClaimFormKey.IS_PERSONAL_EXPENSE]: {
        key: ExpenseClaimFormKey.IS_PERSONAL_EXPENSE,
        label: 'Paid by employee',
        defaultLabel: 'Paid by employee',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.INVOICE_NO]: {
        key: ExpenseClaimFormKey.INVOICE_NO,
        label: 'Invoice No',
        defaultLabel: 'Invoice No',
        required: false,
        visible: true,
        disabled: false,
      },
      [ExpenseClaimFormKey.PNR_NO]: {
        key: ExpenseClaimFormKey.PNR_NO,
        label: 'PNR No',
        defaultLabel: 'PNR No',
        required: false,
        visible: true,
        disabled: false,
      },
      [ExpenseClaimFormKey.INVOICE_DATE]: {
        key: ExpenseClaimFormKey.INVOICE_DATE,
        label: 'Invoice Date',
        defaultLabel: 'Invoice Date',
        required: false,
        visible: true,
        disabled: false,
      },
      [ExpenseClaimFormKey.GL_ACCOUNT]: {
        key: ExpenseClaimFormKey.GL_ACCOUNT,
        label: 'Gl Account',
        defaultLabel: 'Gl Account',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.GST_CODE]: {
        key: ExpenseClaimFormKey.GST_CODE,
        label: 'GST Code',
        defaultLabel: 'GST Code',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.MODE_OF_TRANSPORT]: {
        key: ExpenseClaimFormKey.MODE_OF_TRANSPORT,
        label: 'Mode of transport',
        defaultLabel: 'Mode of transport',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.COST_CENTER]: {
        key: ExpenseClaimFormKey.COST_CENTER,
        label: 'Cost Center',
        defaultLabel: 'Cost Center',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.VEHICLE_NO]: {
        key: ExpenseClaimFormKey.VEHICLE_NO,
        label: 'Vehicle No',
        defaultLabel: 'Vehicle No',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.LAN_NO]: {
        key: ExpenseClaimFormKey.LAN_NO,
        label: 'LAN No',
        defaultLabel: 'LAN No',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.CUSTOMER]: {
        key: ExpenseClaimFormKey.CUSTOMER,
        label: 'Customer',
        defaultLabel: 'Customer',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.DSA_CODE]: {
        key: ExpenseClaimFormKey.DSA_CODE,
        label: 'DSA Code',
        defaultLabel: 'DSA Code',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.REMARKS]: {
        key: ExpenseClaimFormKey.REMARKS,
        label: 'Remarks',
        defaultLabel: 'Remarks',
        required: true,
        visible: true,
        disabled: false,
      },

      [ExpenseClaimFormKey.HOTEL_NAME]: {
        key: ExpenseClaimFormKey.HOTEL_NAME,
        label: 'Hotel Name',
        defaultLabel: 'Hotel Name',
        required: false,
        visible: false,
        disabled: false,
      },

      [ExpenseClaimFormKey.HOTEL_ADDRESS]: {
        key: ExpenseClaimFormKey.HOTEL_ADDRESS,
        label: 'Hotel Address',
        defaultLabel: 'Hotel Address',
        required: false,
        visible: false,
        disabled: false,
      },

      [ExpenseClaimFormKey.HOTEL_COUNTRY]: {
        key: ExpenseClaimFormKey.HOTEL_COUNTRY,
        label: 'Hotel Country',
        defaultLabel: 'Hotel Country',
        required: false,
        visible: false,
        disabled: false,
      },

      [ExpenseClaimFormKey.HOTEL_STATE]: {
        key: ExpenseClaimFormKey.HOTEL_STATE,
        label: 'Hotel State',
        defaultLabel: 'Hotel State',
        required: false,
        visible: false,
        disabled: false,
      },

      [ExpenseClaimFormKey.HOTEL_CITY]: {
        key: ExpenseClaimFormKey.HOTEL_CITY,
        label: 'Hotel City',
        defaultLabel: 'Hotel City',
        required: false,
        visible: false,
        disabled: false,
      },

      [ExpenseClaimFormKey.GST_IN]: {
        key: ExpenseClaimFormKey.GST_IN,
        label: 'GSTIN',
        defaultLabel: 'GSTIN',
        required: false,
        visible: true,
        disabled: false,
      },

      [ExpenseClaimFormKey.HOTEL_PHONE_NUMBER]: {
        key: ExpenseClaimFormKey.HOTEL_PHONE_NUMBER,
        label: 'Hotel Phone No.',
        defaultLabel: 'Hotel Phone No.',
        required: false,
        visible: false,
        disabled: false,
      },

      [ExpenseClaimFormKey.BILL_TO_CUSTOMER]: {
        key: ExpenseClaimFormKey.BILL_TO_CUSTOMER,
        label: 'Bill to Customer',
        defaultLabel: 'Bill to Customer',
        required: false,
        visible: false,
        disabled: false,
      },
      [ExpenseClaimFormKey.NO_OF_DAYS]: {
        key: ExpenseClaimFormKey.NO_OF_DAYS,
        label: 'No of days',
        defaultLabel: 'No of days',
        required: false,
        visible: false,
        disabled: false,
      },
    },
    required: true,
    visible: true,
  },
  [TravelRequestLineItemSection.PER_DIEM]: {
    fields: {
      [PerDiemFormKeys.CITY]: {
        key: PerDiemFormKeys.CITY,
        label: 'City',
        defaultLabel: 'City',
        required: true,
        visible: true,
        disabled: false,
      },
      [PerDiemFormKeys.FROM_DATE]: {
        key: PerDiemFormKeys.FROM_DATE,
        label: 'From Date',
        defaultLabel: 'From Date',
        required: true,
        visible: true,
        disabled: false,
      },
      [PerDiemFormKeys.TO_DATE]: {
        key: PerDiemFormKeys.TO_DATE,
        label: 'To Date',
        defaultLabel: 'To Date',
        required: true,
        visible: true,
        disabled: false,
      },
      [PerDiemFormKeys.NO_OF_DAYS]: {
        key: PerDiemFormKeys.NO_OF_DAYS,
        label: 'No of days',
        defaultLabel: 'No of days',
        required: true,
        visible: true,
        disabled: false,
      },
      [PerDiemFormKeys.RATE]: {
        key: PerDiemFormKeys.RATE,
        label: 'Rate (Per Day)',
        defaultLabel: 'Rate (Per Day)',
        required: true,
        visible: true,
        disabled: false,
      },
      [PerDiemFormKeys.TOTAL]: {
        key: PerDiemFormKeys.TOTAL,
        label: 'Claim Amount',
        defaultLabel: 'Claim Amount',
        required: true,
        visible: true,
        disabled: false,
      },
      [PerDiemFormKeys.REMARKS]: {
        key: PerDiemFormKeys.REMARKS,
        label: 'Remarks',
        defaultLabel: 'Remarks',
        required: true,
        visible: true,
        disabled: false,
      },
    },
    required: false,
    visible: false,
  },
  [TravelRequestLineItemSection.PER_KM]: {
    fields: {
      [PerKmClaimFormKeys.MODE_OF_TRANSPORT]: {
        key: PerKmClaimFormKeys.MODE_OF_TRANSPORT,
        label: 'Mode of Transport',
        defaultLabel: 'Mode of Transport',
        required: true,
        visible: true,
        disabled: false,
      },
      [PerKmClaimFormKeys.FROM_DATE]: {
        key: PerKmClaimFormKeys.FROM_DATE,
        label: 'From Date',
        defaultLabel: 'From Date',
        required: true,
        visible: true,
        disabled: false,
      },
      [PerKmClaimFormKeys.TO_DATE]: {
        key: PerKmClaimFormKeys.TO_DATE,
        label: 'To Date',
        defaultLabel: 'To Date',
        required: true,
        visible: true,
        disabled: false,
      },
      [PerKmClaimFormKeys.SOURCE]: {
        key: PerKmClaimFormKeys.SOURCE,
        label: 'Source',
        defaultLabel: 'Source',
        required: true,
        visible: true,
        disabled: false,
      },
      [PerKmClaimFormKeys.DESTINATION]: {
        key: PerKmClaimFormKeys.DESTINATION,
        label: 'Destination',
        defaultLabel: 'Destination',
        required: true,
        visible: true,
        disabled: false,
      },
      [PerKmClaimFormKeys.FROM_METER]: {
        key: PerKmClaimFormKeys.FROM_METER,
        label: 'Meter (From)',
        defaultLabel: 'Meter (From)',
        required: true,
        visible: true,
        disabled: false,
      },
      [PerKmClaimFormKeys.TO_METER]: {
        key: PerKmClaimFormKeys.TO_METER,
        label: 'Meter (To)',
        defaultLabel: 'Meter (To)',
        required: true,
        visible: true,
        disabled: false,
      },
      [PerKmClaimFormKeys.DISTANCE_IN_KM]: {
        key: PerKmClaimFormKeys.DISTANCE_IN_KM,
        label: 'Distance (In Km)',
        defaultLabel: 'Distance (In Km)',
        required: true,
        visible: true,
        disabled: false,
      },
      [PerKmClaimFormKeys.RATE_PER_KM]: {
        key: PerKmClaimFormKeys.RATE_PER_KM,
        label: 'Rate (Per Km)',
        defaultLabel: 'Rate (Per Km)',
        required: true,
        visible: true,
        disabled: false,
      },
      [PerKmClaimFormKeys.TOTAL]: {
        key: PerKmClaimFormKeys.TOTAL,
        label: 'Total',
        defaultLabel: 'Total',
        required: true,
        visible: true,
        disabled: false,
      },
      [PerKmClaimFormKeys.APPROVED_AMOUNT]: {
        key: PerKmClaimFormKeys.APPROVED_AMOUNT,
        label: 'Approved Amount',
        defaultLabel: 'Approved Amount',
        required: true,
        visible: true,
        disabled: false,
      },
      [PerKmClaimFormKeys.REMARKS]: {
        key: PerKmClaimFormKeys.REMARKS,
        label: 'Remarks',
        defaultLabel: 'Remarks',
        required: true,
        visible: true,
        disabled: false,
      },
    },
    required: true,
    visible: true,
  },
  [TravelRequestLineItemSection.ATTACHMENTS]: {
    fields: null,
    required: true,
    visible: true,
  },
};

export const DEFAULT_TRAVEL_APPROVAL_DROPDOWN: IAntdDropdown[] = [
  {
    label: 'Default',
    value: TravelRequestApprovalType.DEFAULT,
  },
  {
    label: 'Exception',
    value: TravelRequestApprovalType.EXCEPTION,
  },
];

export const REVIEW_TYPE_DROPDOWN_OPTIONS = [
  {
    label: 'Skip',
    value: ReviewType.SKIP,
  },
  {
    label: 'Reset',
    value: ReviewType.RESET,
  },
];

export const APPROVAL_STATUS_LABEL_MAP = {
  [SystemApprovalStatus.PENDING]: 'Pending',
  [SystemApprovalStatus.APPROVED]: 'Approved',
  [SystemApprovalStatus.REJECTED]: 'Rejected',
  [SystemApprovalStatus.HOLD]: 'Hold',
  [SystemApprovalStatus.IN_REVIEW]: 'In Review',
  [SystemApprovalStatus.CANCELLED]: 'Cancelled',
};

export const SUBMISSION_STATUS_LABEL_MAP = {
  [SystemSubmissionStatus.DRAFT]: 'Draft',
  [SystemSubmissionStatus.SUBMITTED]: 'Submitted',
};

export const CREATOR_LEVEL = 0;

export const TRAVEL_LIFECYCLE_STATUS_LABELS: Record<
  TravelLifecycleStatus,
  string
> = {
  ACTIVE: 'Active Claims',
  AWAITING_FINAL_APPROVAL: 'Awaiting Final Approval',
  PENDING: 'Pending',
  IN_REVIEW: 'In Review',
  HOLD: 'On Hold',
  AWAITING_CLAIM: 'Awaiting Claim',
  APPROVED: 'Final Approved',
  REJECTED: 'Rejected',
  CANCELLED: 'Cancelled',
  UNCLASSIFIED: 'Other',
  DRAFT: 'Draft',
};

export const TRAVEL_LIFECYCLE_STATUS_OPTIONS = Object.entries(
  TRAVEL_LIFECYCLE_STATUS_LABELS,
)
  .filter(([value]) => value !== 'DRAFT')
  .map(([value, label]) => ({
    value: value as TravelLifecycleStatus,
    label,
  }));

export const LIMIT_FREQUENCY_DROPDOWN = [
  { label: 'Per Quarter', value: ClaimLimitType.PER_QUARTER },
  { label: 'Per Month', value: ClaimLimitType.PER_MONTH },
  { label: 'Per Year', value: ClaimLimitType.PER_YEAR },
  { label: 'Per Day', value: ClaimLimitType.PER_DAY },
];

export const ANTI_PATTERN_ERROR_TYPE_DROPDOWN = [
  { label: 'Error', value: AntiPatternErrorType.ERROR },
  { label: 'Warning', value: AntiPatternErrorType.WARNING },
  { label: 'Info', value: AntiPatternErrorType.INFO },
];

export const TOUR_REQUEST_TYPE_DROPDOWN = [
  { label: 'Tour Request', value: TourRequestType.REQUEST },
  { label: 'Claim', value: TourRequestType.CLAIM },
];

export const TOUR_REQUEST_LABEL_MAP: Record<TourRequestType, string> = {
  [TourRequestType.REQUEST]: 'Tour Request',
  [TourRequestType.CLAIM]: 'Claim',
};

export const TRAVEL_REQUEST_LINE_ITEM_SECTION_LABEL_MAP: Record<
  TravelRequestLineItemSection,
  string
> = {
  [TravelRequestLineItemSection.HEADER]: 'Header',
  [TravelRequestLineItemSection.MODE_OF_JOURNEY]: 'Mode Of Journey',
  [TravelRequestLineItemSection.ACCOMMODATION_TYPE]: 'Accommodation',
  [TravelRequestLineItemSection.EXPENSE_CLAIM]: 'Employee Expenses',
  [TravelRequestLineItemSection.OFFICE_EXPENSE_CLAIM]: 'Company Expenses',
  [TravelRequestLineItemSection.PER_DIEM]: 'Per Diem',
  [TravelRequestLineItemSection.PER_KM]: 'Conveyance',
  [TravelRequestLineItemSection.ATTACHMENTS]: 'Additional Attachments',
};
